import moment from "moment";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { exportUnreconciledExcel, exportAllTransactionsExcel } from "../../services/EventService";
import FullPageLoader from "./FullPageLoader";
import { useState } from "react";
import { generateToast } from "../../helper";
import { ERROR, SUCCESS } from "../../constant";
import { useSelector } from "react-redux";

const styles = {
  container: {
    display: "inline-flex",
    alignItems: "center",
    marginLeft: "8px",
  },
  buttonGroup: {
    boxShadow: "none",
  },
  button: (isDark, color) => ({
    height: "2.1rem",
    fontSize: "11px",
    textTransform: "none",
    fontWeight: 500,
    padding: "4px 12px",
    border: `1px solid ${isDark ? "rgba(255,255,255,0.23)" : color}`,
    backgroundColor: "transparent",
    whiteSpace: "nowrap",
  }),
  icon: (color) => ({
    color: color,
    fontSize: "18px",
    marginRight: "4px",
  }),
  label: (isDark, color) => ({
    color: isDark ? "white" : color,
  }),
};

const UnreconciledExport = ({ mode }) => {
  const [excelLoading, setExcelLoading] = useState(false);
  const [allTransactionsLoading, setAllTransactionsLoading] = useState(false);
  const {
    Contracts: { filter },
  } = useSelector((state) => state);

  const isDark = mode === "dark";
  const isLoading = excelLoading || allTransactionsLoading;

  const getExportParams = () => {
    const params = {};
    if (filter?.startEventDate) params.startEventDate = filter.startEventDate;
    if (filter?.endEventDate) params.endEventDate = filter.endEventDate;
    return params;
  };

  const downloadFile = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleExportUnreconciled = async () => {
    try {
      setExcelLoading(true);
      const blob = await exportUnreconciledExcel(getExportParams());
      if (!blob) throw new Error("No data received from server");
      downloadFile(blob, `unreconciled-transactions-${moment().format("YYYY-MM-DD")}.xlsx`);
      generateToast("Unreconciled transactions exported successfully!", SUCCESS);
    } catch (error) {
      console.error("Export error:", error);
      generateToast(error.message || "Failed to export. Please try again.", ERROR);
    } finally {
      setExcelLoading(false);
    }
  };

  const handleExportAllTransactions = async () => {
    try {
      setAllTransactionsLoading(true);
      const blob = await exportAllTransactionsExcel(getExportParams());
      if (!blob) throw new Error("No data received from server");
      downloadFile(blob, `all-transactions-${moment().format("YYYY-MM-DD")}.xlsx`);
      generateToast("All transactions exported successfully!", SUCCESS);
    } catch (error) {
      console.error("Export error:", error);
      generateToast(error.message || "Failed to export. Please try again.", ERROR);
    } finally {
      setAllTransactionsLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <ButtonGroup variant="outlined" size="small" style={styles.buttonGroup}>
        <Button
          style={styles.button(isDark, "#FF9800")}
          onClick={handleExportUnreconciled}
          disabled={isLoading}
        >
          <FileDownloadIcon style={styles.icon("#FF9800")} />
          <span style={styles.label(isDark, "#FF9800")}>Unreconciled</span>
        </Button>
        <Button
          style={styles.button(isDark, "#4CAF50")}
          onClick={handleExportAllTransactions}
          disabled={isLoading}
        >
          <FileDownloadIcon style={styles.icon("#4CAF50")} />
          <span style={styles.label(isDark, "#4CAF50")}>All Transactions</span>
        </Button>
      </ButtonGroup>
      {isLoading && <FullPageLoader />}
    </div>
  );
};

export default UnreconciledExport;

